import Styled from "styled-components";
import { Button } from "semantic-ui-react";
import { buttonTextColor } from "./ViewSetsCreateNewFilterDropdown";

/* TODO: replace use with tailwind button component  */
export const StyledViewSetButton = Styled(Button)`
  &&& {
    color: ${buttonTextColor}
    margin-bottom: 0;
    margin-left: 4px;
  }
  &:hover,
  &:focus {
    border: none !important;
    opacity: 1 !important;
  }
`;
